var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.25,14.625h-27A2.25,2.25,0,0,0,0,16.875v2.25a2.25,2.25,0,0,0,2.25,2.25h27a2.25,2.25,0,0,0,2.25-2.25v-2.25A2.25,2.25,0,0,0,29.25,14.625Z","transform":"translate(0 -14.625)","fill":"#ffba00"}));
}

Minus.defaultProps = {"width":"31.5","height":"6.75","viewBox":"0 0 31.5 6.75"};

module.exports = Minus;

Minus.default = Minus;
